import React from 'react';
import './TrackPill.css';

interface TrackPillProps {
  track: string;
}

const TrackPill: React.FC<TrackPillProps> = ({ track }) => {
  // Extraer el nombre y el color del track (formato "nombre&&&color")
  const parts = track.split('&&&');
  const trackName = parts[0];
  const trackColor = parts.length > 1 && parts[1] ? parts[1] : 'var(--ion-color-primary)';

  // Generar una clase CSS basada en el nombre del track para compatibilidad con estilos existentes
  const trackClass = `session-track-${trackName.toLowerCase().replace(/ /g, '-')}`;

  // Determinar si estamos en modo oscuro
  const isDarkMode = document.body.classList.contains('dark-theme');

  return (
    <span
      className={`track-pill rounded-full text-xs font-medium px-2 py-0 text-white ${trackClass}`}
      style={{
        backgroundColor: trackColor,
        boxShadow: isDarkMode ? '0 2px 4px rgba(0, 0, 0, 0.5)' : undefined,
        textShadow: isDarkMode ? '0 1px 2px rgba(0, 0, 0, 0.5)' : undefined,
        border: isDarkMode ? '1px solid rgba(255, 255, 255, 0.1)' : undefined,
        fontWeight: isDarkMode ? 'bold' : undefined
      }}
    >
      {trackName}
    </span>
  );
};

export default TrackPill;
